/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import * as queryString from 'query-string';
import { getApiErrorMessage } from '../utils/apiError';

import { gtag } from '../components/Analytics/gtag';
import * as tmsEventsApi from '../api/tmsEventsApi';
import * as eventsApi from '../api/eventsApi';
import * as clubsApi from '../api/clubsApi';
import { postScore, clearScore, sendMessage } from '../api';
import { submitEventBannerCrop, removeEventBannerPhoto } from '../api/uploadApi';
import { filterMembers } from '../utils/members';
import ActionTypes from './actionTypes/index';
import eventsConstants from '../../constants/events';
import { getAdultTeamTennisEvents } from './club-actions';
import { isTeamTennisClub } from '../utils/clubs';
import EventTours from '../utils/EventTours';
import { EventTypes } from '../utils/events';
import { sortObjectsByProp } from '../utils';
import { acceptanceRankingValues } from '../utils/eventConstants';
import { EVENT_PROFILE_SET_JUST_PUBLISHED_FLAG } from './actionTypes/event-profile-action-types';
import { showErrorPopup, showSuccessToast } from './notification-actions';
import { NOTIFICATIONS_SHOW_SUCCESS_TOAST } from './actionTypes/notification-action-types';
import * as drawEditActions from './draw-edit-actions';
import { getRegistrations, getCurrentMemberRegistration } from './event-profile-actions';

const {
    EVENTS_REINIT_STATE,
    EVENTS_SET_JUST_PUBLISHED_FLAG,
    EVENTS_CLEAR_JUST_PUBLISHED_FLAG,
    EVENTS_SAVE_REQUEST,
    EVENTS_SAVE_SUCCESS,
    EVENTS_SAVE_FAILURE,
    EVENTS_INVITE_PLAYERS_REQUEST,
    EVENTS_INVITE_PLAYERS_SUCCESS,
    EVENTS_INVITE_PLAYERS_FAILURE,
    EVENTS_UPDATE_REQUEST,
    EVENTS_UPDATE_SUCCESS,
    EVENTS_UPDATE_FAILURE,
    EVENTS_DELETE_FAILURE,
    EVENTS_DRAWS_FETCH_REQUEST,
    EVENTS_DRAWS_FETCH_SUCCESS,
    EVENTS_DRAWS_FETCH_FAILURE,
    EVENTS_LOCATIONS_FETCH_REQUEST,
    EVENTS_LOCATIONS_FETCH_SUCCESS,
    EVENTS_LOCATIONS_FETCH_FAILURE,
    EVENTS_LOCATIONS_EXCLUDE_REQUEST,
    EVENTS_LOCATIONS_EXCLUDE_SUCCESS,
    EVENTS_LOCATIONS_EXCLUDE_FAILURE,
    EVENTS_OFFICIALS_FETCH_REQUEST,
    EVENTS_OFFICIALS_FETCH_SUCCESS,
    EVENTS_OFFICIALS_FETCH_FAILURE,
    EVENTS_OFFICIALS_UPDATE_REQUEST,
    EVENTS_OFFICIALS_UPDATE_SUCCESS,
    EVENTS_OFFICIALS_UPDATE_FAILURE,
    EVENTS_GET_MATCH_OFFICIALS_REQUEST,
    EVENTS_GET_MATCH_OFFICIALS_SUCCESS,
    EVENTS_GET_MATCH_OFFICIALS_FAILURE,
    EVENTS_ADD_MATCH_OFFICIAL_REQUEST,
    EVENTS_ADD_MATCH_OFFICIAL_FAILURE,
    EVENTS_DELETE_MATCH_OFFICIAL_REQUEST,
    EVENTS_DELETE_MATCH_OFFICIAL_SUCCESS,
    EVENTS_DELETE_MATCH_OFFICIAL_FAILURE,
    EVENTS_ACCEPTANCE_FETCH_REQUEST,
    EVENTS_ACCEPTANCE_FETCH_SUCCESS,
    EVENTS_ACCEPTANCE_FETCH_FAILURE,
    EVENTS_FETCH_REQUEST,
    EVENTS_FETCH_SUCCESS,
    EVENTS_FETCH_FAILURE,
    EVENTS_DRAWS_VIEW_FETCH_REQUEST,
    EVENTS_DRAWS_VIEW_FETCH_SUCCESS,
    EVENTS_DRAWS_VIEW_FETCH_FAILURE,
    EVENTS_REG_SUCCESS,
    EVENTS_DRAWS_INIT_REQUEST,
    EVENTS_DRAWS_INIT_SUCCESS,
    EVENTS_DRAWS_INIT_FAILURE,
    EVENTS_DRAWS_DELETE_REQUEST,
    EVENTS_DRAWS_DELETE_SUCCESS,
    EVENTS_DRAWS_DELETE_FAILURE,
    EVENTS_RESET_REQUEST,
    EVENTS_RESET_SUCCESS,
    EVENTS_RESET_FAILURE,
    EVENTS_DRAWS_AUTOFILL_REQUEST,
    EVENTS_DRAWS_AUTOFILL_SUCCESS,
    EVENTS_DRAWS_AUTOFILL_FAILURE,
    EVENTS_DRAWS_PUBLISH_REQUEST,
    EVENTS_DRAWS_PUBLISH_SUCCESS,
    EVENTS_DRAWS_PUBLISH_FAILURE,
    EVENTS_DRAWS_SAVE_REQUEST,
    EVENTS_DRAWS_SAVE_SUCCESS,
    EVENTS_DRAWS_SAVE_FAILURE,
    EVENTS_POST_SCORE_REQUEST,
    EVENTS_POST_SCORE_SUCCESS,
    EVENTS_POST_SCORE_FAILURE,
    EVENTS_SEND_INVITATION_TO_GROUP,
    EVENTS_SEND_INVITATION_TO_GROUP_SUCCESS,
    EVENTS_SEND_INVITATION_TO_GROUP_FAILURE,
    EVENTS_SEND_MESSAGE_TO_PLAYERS,
    EVENTS_SEND_MESSAGE_TO_PLAYERS_SUCCESS,
    EVENTS_SEND_MESSAGE_TO_PLAYERS_FAILURE,
    EVENTS_CLEAR_SCORE_REQUEST,
    EVENTS_CLEAR_SCORE_SUCCESS,
    EVENTS_CLEAR_SCORE_FAILURE,
    EVENTS_UPLOAD_ATTACHMENT_REQUEST,
    EVENTS_UPLOAD_ATTACHMENT_SUCCESS,
    EVENTS_UPLOAD_ATTACHMENT_FAILURE,
    EVENTS_FETCH_ATTACHMENT_REQUEST,
    EVENTS_FETCH_ATTACHMENT_SUCCESS,
    EVENTS_FETCH_ATTACHMENT_FAILURE,
    EVENTS_REGPAYMENTS_FETCH_REQUEST,
    EVENTS_REGPAYMENTS_FETCH_SUCCESS,
    EVENTS_REGPAYMENTS_FETCH_FAILURE,
    EVENTS_SET_OVERVIEW_TAB_STATE,
    EVENTS_SET_DRAWS_TAB_STATE,
    EVENTS_SET_PLAYERS_TAB_STATE,
    EVENTS_CLONE_REQUEST,
    EVENTS_CLONE_SUCCESS,
    EVENTS_CLONE_FAILURE,
    EVENTS_HIDE_DELETE_FAILED_POPUP,
    EVENTS_REG_ADD_TEAMMATE,
    EVENTS_UPDATE_DRAWS,
    EVENTS_UPDATE_SCHEDULE_TYPE,
    EVENTS_UPDATE_SCHEDULE_TYPE_REQUEST,
    EVENTS_UPDATE_SCHEDULE_TYPE_SUCCESS,
    EVENTS_UPDATE_SCHEDULE_TYPE_FAILURE,
    EVENTS_FETCH_MATCH_SHEET_SUCCESS,
    EVENTS_UPDATE_MATCH_SHEET_REQUEST,
    EVENTS_UPDATE_MATCH_SHEET_SUCCESS,
    EVENTS_DELETE_MATCH_SHEET_SUCCESS,
    EVENTS_UPDATE_MATCH_SHEET_FAILURE,
    EVENTS_UPDATE_MATCH_SHEET_ROUND_REQUEST,
    EVENTS_UPDATE_MATCH_SHEET_ROUND_SUCCESS,
    EVENTS_UPDATE_MATCH_SHEET_ROUND_FAILURE,
    EVENTS_GET_DRAW_OFFICIALS_REQUEST,
    EVENTS_GET_DRAW_OFFICIALS_FAILURE,
    EVENTS_GET_DRAW_OFFICIALS_SUCCESS,
    EVENTS_ORDER_OF_PLAY_FETCH_SUCCESS,
    EVENTS_ORDER_OF_PLAY_SAVE_SUCCESS,
    EVENTS_ORDER_OF_PLAY_DELETE_SUCCESS,
    EVENTS_EVENT_TEAM_STANDINGS_SUCCESS,
    EVENTS_DELETE_TEAM_STANDING_SUCCESS,
    EVENTS_EDIT_TEAM_STANDING_SUCCESS,
    EVENTS_INCLUDE_IN_CONFERENCE_REQUEST,
    EVENTS_INCLUDE_IN_CONFERENCE_SUCCESS,
    EVENTS_INCLUDE_IN_CONFERENCE_FAILURE,
    EVENTS_OMIT_FROM_CONFERENCE_REQUEST,
    EVENTS_OMIT_FROM_CONFERENCE_SUCCESS,
    EVENTS_OMIT_FROM_CONFERENCE_FAILURE,
    EVENTS_PUBLISH_SUCCESS,
    EVENTS_UNPUBLISH_SUCCESS,
    EVENTS_DELETE_SUCCESS,
    EVENTS_DRAW_CONTACTS_SUCCESS,
    EVENTS_SAFESPORT_FETCH_REQUEST,
    EVENTS_SAFESPORT_FETCH_SUCCESS,
    EVENTS_SAFESPORT_FETCH_FAILURE,
    // EVENTS_GET_INVITATIONS_SUCCESS,
    EVENTS_ACCEPT_INVITE_SUCCESS,
    EVENTS_DECLINE_INVITE_SUCCESS,
    EVENTS_GET_EVENT_REGIONS_SUCCESS,
    EVENTS_GET_EVENT_REGIONS_FETCH,
    EVENTS_SET_PLAYER_WILDCARD,
    EVENTS_SET_PLAYER_WILDCARD_SUCCESS,
    EVENTS_GET_ORGANIZER_RATINGS_SUCCESS,
    EVENTS_SET_ORGANIZER_RATINGS_SUCCESS,
    EVENTS_MOVE_PLAYER_TO_ROUND,
    EVENTS_MOVE_PLAYER_TO_ROUND_SUCCESS,
    EVENTS_SET_DRAW_TAG,
    EVENTS_SET_DRAW_TAG_SUCCESS,
    EVENTS_POST_NCSA_REG,
    EVENTS_POST_NCSA_REG_SUCCESS,
    EVENTS_POST_NCSA_REG_FAILURE,
    EVENTS_META_FETCH_SUCCESS,
    EVENTS_UPDATE_TEAM_SCORES_SUCCESS,
    EVENTS_CROP_BANNER_PHOTO_SUCCESS,
    EVENTS_REMOVE_BANNER_PHOTO_SUCCESS,
    EVENTS_SHOW_ADMIN_SPLASH,
    EVENTS_HIDE_ADMIN_SPLASH,
    EVENTS_UPDATE_MATCH_POSITION_REQUEST,
    EVENTS_UPDATE_MATCH_POSITION_SUCCESS,
    EVENTS_ADD_MATCH_TO_ROUND,
    EVENTS_DELETE_MATCH,
    EVENTS_ADD_DRAW,
    EVENTS_UPDATE_DRAW,
    EVENTS_INCLUDE_IN_ATT_STANDINGS_SUCCESS,
    EVENTS_OMIT_FROM_ATT_STANDINGS_SUCCESS,
} = ActionTypes;

export const initState = () => (dispatch) => {
    dispatch({
        type: EVENTS_REINIT_STATE,
    });
};
export const hideAdminSplash = () => (dispatch) => {
    dispatch({
        type: EVENTS_HIDE_ADMIN_SPLASH,
    });
};
export const showAdminSplash = (message, timeout) => (dispatch) => {
    dispatch({
        type: EVENTS_SHOW_ADMIN_SPLASH,
        message,
    });
    setTimeout(() => {
        dispatch(hideAdminSplash());
    }, timeout || 3000);
};

export const getEventTeamStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.getTeamStandings(mainApi, eventId);

    if (response.status === 200) {
        dispatch({
            type: EVENTS_EVENT_TEAM_STANDINGS_SUCCESS,
            payload: response.data.standings,
        });
    }
};

const invitePlayersAfterSave = (eventId, playersList) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_INVITE_PLAYERS_REQUEST });
    try {
        const inviteResult = await eventsApi.invitePlayersToEvent(mainApi, eventId, {
            eventInvites: playersList,
        });
        const inviteData = inviteResult.data;
        if (inviteData.error) {
            dispatch({ type: EVENTS_INVITE_PLAYERS_FAILURE, data: { playersInvited: false } });
        } else {
            dispatch({ type: EVENTS_INVITE_PLAYERS_SUCCESS, data: { data: inviteData, playersInvited: true } });
        }
    } catch {
        dispatch({ type: EVENTS_INVITE_PLAYERS_FAILURE, data: { playersInvited: false } });
    }
};

const saveEventApiCall = (mainApi, values, isDualMatchEvent, cloneEventId) => {
    if (isDualMatchEvent && cloneEventId) {
        return tmsEventsApi.cloneDualMatchEvent(mainApi, values, cloneEventId);
    }
    if (isDualMatchEvent) {
        return tmsEventsApi.createDualMatchEvent(mainApi, values);
    }
    return tmsEventsApi.save(mainApi, values);
};

export const saveEvent = (values, isDualMatchEvent, cloneEventId) => async (dispatch, getState, { mainApi }) => {
    if (values.$justPublished) {
        dispatch({ type: EVENTS_SET_JUST_PUBLISHED_FLAG });
        dispatch({ type: EVENT_PROFILE_SET_JUST_PUBLISHED_FLAG, payload: true });
    }
    dispatch({ type: EVENTS_SAVE_REQUEST });
    try {
        const res = await saveEventApiCall(mainApi, values, isDualMatchEvent, cloneEventId);
        if (res.data.error) {
            dispatch({ type: EVENTS_SAVE_FAILURE, res });
            return undefined;
        }
        if (values.playersList?.length) {
            await dispatch(invitePlayersAfterSave(res.data.id, values.playersList));
        }
        dispatch({ type: EVENTS_SAVE_SUCCESS, res });
        return res.data;
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error saving event',
            error,
        }));
        dispatch({ type: EVENTS_SAVE_FAILURE });
        return undefined;
    }
};

export const updateEvent = (values, isDualMatchEvent) => async (dispatch, getState, { mainApi }) => {
    if (values.$justPublished) {
        dispatch({ type: EVENTS_SET_JUST_PUBLISHED_FLAG });
        dispatch({ type: EVENT_PROFILE_SET_JUST_PUBLISHED_FLAG, payload: true });
    }
    dispatch({ type: EVENTS_UPDATE_REQUEST });
    try {
        const res = isDualMatchEvent ? await tmsEventsApi.updateDualMatchEvent(mainApi, values) : await tmsEventsApi.save(mainApi, values);
        if (res.data.error) {
            dispatch({
                type: EVENTS_UPDATE_FAILURE,
                res,
            });
        } else {
            dispatch({
                type: EVENTS_UPDATE_SUCCESS,
                res,
            });
            return res.data;
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error saving event',
            error,
        }));
        dispatch({
            type: EVENTS_UPDATE_FAILURE,
        });
    }
};

export const deleteEvent = (showSplash = true) => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    if (showSplash) {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Deleting',
            description: 'Please wait while we\'re deleting your event',
        });
    }
    const res = await tmsEventsApi.deleteEvent(mainApi, event.id);
    try {
        if (res?.data.status === 'success') {
            if (showSplash) {
                dispatch({ type: 'SPLASH_HIDE' });
            }
            dispatch(showAdminSplash('Your event has been deleted!'));
            dispatch({ type: EVENTS_DELETE_SUCCESS, eventId: event.id });
            if (isTeamTennisClub(event.club.tierType)) {
                dispatch(getAdultTeamTennisEvents({ clubId: event.club.id }));
            }
            return true;
        }
        if (showSplash) {
            dispatch({ type: 'SPLASH_HIDE' });
        }
        dispatch(showErrorPopup({
            error: 'Error deleting event',
        }));
        dispatch({ type: EVENTS_DELETE_FAILURE });
    } catch (e) {
        if (showSplash) {
            dispatch({ type: 'SPLASH_HIDE' });
        }
        dispatch(showErrorPopup({
            message: 'Error deleting event',
            error: e,
        }));
        dispatch({ type: EVENTS_DELETE_FAILURE });
    }
};

export const cloneEvent = () => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_CLONE_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Duplicating',
        description: 'Please wait while we\'re duplicating event',
    });
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    try {
        const res = await tmsEventsApi.cloneEvent(mainApi, event.id);
        if (res.data.error) {
            dispatch({ type: EVENTS_CLONE_FAILURE, res });
        } else {
            dispatch({ type: EVENTS_CLONE_SUCCESS, res });
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch({ type: EVENTS_CLONE_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error resetting event',
            error,
        }));
    }
};

export const showDeleteFailedPopup = () => async (dispatch) => {
    dispatch({ type: EVENTS_DELETE_FAILURE });
};

export const closeDeleteFailedPopup = () => async (dispatch) => {
    dispatch({ type: EVENTS_HIDE_DELETE_FAILED_POPUP });
};

export const initDrawsTabState = ({ d: drawId, r: round, standings }) => (dispatch, getState) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;

    let drawIndex;
    let childDrawIndex;
    // if draw/round data was passed as query params
    if (drawId) {
        // find parent draw index by child or parent draw id
        event.draws.forEach((draw, i) => {
            if (draw.id === drawId) {
                drawIndex = i;
            } else if (draw.childDraws?.length) {
                draw.childDraws.forEach((childDraw, j) => {
                    if (childDraw.id === drawId) {
                        drawIndex = i;
                        childDrawIndex = j;
                    }
                });
            }
        });
        // else find first published draw
    } else {
        drawIndex = event.draws.findIndex(draw => draw.published) || 0;
    }
    let selectedDraw = event.draws[drawIndex];
    let childDraws = [];
    if (event.draws[drawIndex]?.childDraws) {
        if (event.draws[drawIndex]?.drawCategoryType?.value === 'grouped') {
            selectedDraw = typeof childDrawIndex === 'number'
                ? event.draws[drawIndex].childDraws[childDrawIndex]
                : event.draws[drawIndex].childDraws.sort(sortObjectsByProp('name'))[0];
            childDraws = event.draws[drawIndex]?.childDraws.sort(sortObjectsByProp('name')).map((childDraw) => {
                return {
                    value: childDraw.id,
                    label: childDraw.name,
                };
            });
        } else {
            selectedDraw = typeof childDrawIndex === 'number'
                ? event.draws[drawIndex].childDraws[childDrawIndex]
                : event.draws[drawIndex];
            childDraws = event.draws[drawIndex]?.childDraws.map((childDraw) => {
                if (childDraw.id && childDraw.drawCategoryType.label) {
                    return {
                        value: childDraw.id,
                        label: childDraw.drawCategoryType.label,
                    };
                }
                return null;
            });
        }
    }

    const drawsTabState = event.draws?.length ? {
        selectedParentDraw: event.draws[drawIndex],
        selectedDraw,
        childDraws,
        activeRound: round ? parseInt(round) : 0,
        showStandings: !!standings,
    } : null;

    dispatch({ type: EVENTS_SET_DRAWS_TAB_STATE, payload: { drawsTabState } });
};

export const defaultInitDrawsTabState = () => (dispatch) => {
    const parsed = queryString.parse(window.location.search);
    const { t, d, r, standings } = parsed;

    dispatch(initDrawsTabState({ t, d, r, standings }));
};

export const setOverviewTabState = (overviewTabState) => (dispatch) => {
    dispatch({ type: EVENTS_SET_OVERVIEW_TAB_STATE, payload: { overviewTabState } });
};

export const setDrawsTabState = (drawsTabState) => (dispatch) => {
    dispatch({ type: EVENTS_SET_DRAWS_TAB_STATE, payload: { drawsTabState } });
};

export const setPlayersTabState = (playersTabState) => (dispatch) => {
    dispatch({ type: EVENTS_SET_PLAYERS_TAB_STATE, payload: { playersTabState } });
};

export const getEventDraws = (eventId, showSplash = false) => async (dispatch, getState, { mainApi }) => {
    try {
        if (showSplash) {
            dispatch({
                type: 'SPLASH_SHOW_LOADING',
                title: 'Loading',
                description: 'Please wait while we\'re loading your event',
            });
        }

        dispatch({ type: EVENTS_DRAWS_FETCH_REQUEST });
        const res = await tmsEventsApi.getDraws(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_DRAWS_FETCH_FAILURE });
        } else {
            dispatch({ type: EVENTS_DRAWS_FETCH_SUCCESS, data });
            dispatch(defaultInitDrawsTabState());
        }

        if (showSplash) {
            dispatch({
                type: 'SPLASH_HIDE',
            });
        }
    } catch {
        dispatch({
            type: EVENTS_DRAWS_FETCH_FAILURE,
        });
    }
};

export const getEventLocations = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_LOCATIONS_FETCH_REQUEST });
        const res = await tmsEventsApi.getEventLocations(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_LOCATIONS_FETCH_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error loading locations.',
                error: data.error,
            }));
        } else {
            dispatch({ type: EVENTS_LOCATIONS_FETCH_SUCCESS, data });
        }
    } catch {
        dispatch({
            type: EVENTS_LOCATIONS_FETCH_FAILURE,
        });
    }
};

export const getMatchSheet = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getMatchSheet(mainApi, eventId);
        const { data } = res;
        dispatch({ type: EVENTS_FETCH_MATCH_SHEET_SUCCESS, data: data.matches });
    } catch (error) {
        console.log(error);
    }
};

export const updateMatchSheet = ({ matchId, payload }) => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    try {
        dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_REQUEST });
        const result = await tmsEventsApi.updateMatchSheet(mainApi, event.id, matchId, payload);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_FAILURE });
        } else {
            dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_SUCCESS, data: { matchId, payload } });
            dispatch(getMatchSheet(event.id));
        }
    } catch {
        dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_FAILURE });
    }
};

export const updateMatchSheetRound = ({ roundId, payload }) => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    try {
        dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_ROUND_REQUEST });
        const result = await tmsEventsApi.updateMatchSheetRound(mainApi, event.id, roundId, payload);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_ROUND_FAILURE });
        } else {
            dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_ROUND_SUCCESS, data: { roundId, payload } });
            dispatch(getMatchSheet(event.id));
        }
    } catch {
        dispatch({ type: EVENTS_UPDATE_MATCH_SHEET_ROUND_FAILURE });
    }
};

export const removeMatchSheet = (eventId, matchId) => async (dispatch, getState, { mainApi }) => {
    try {
        const result = await tmsEventsApi.deleteMatchSheet(mainApi, eventId, matchId);
        if (result.status === 200) {
            dispatch({ type: EVENTS_DELETE_MATCH_SHEET_SUCCESS, data: { matchId } });
            dispatch(getMatchSheet(eventId));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting match sheet.',
            error,
        }));
        throw error;
    }
};

export const removeCourtExclusionList = (exclusionList) => async (dispatch, getState, { mainApi }) => {
    try {
        const { currentEvent } = getState().events;
        const event = currentEvent.data;

        dispatch({ type: EVENTS_LOCATIONS_EXCLUDE_REQUEST });

        await tmsEventsApi.removeCourtFromEventExclusions(mainApi, event.id, { courts: exclusionList });

        dispatch({ type: EVENTS_LOCATIONS_EXCLUDE_SUCCESS });
        dispatch(getEventLocations(event.id));
    } catch {
        dispatch({
            type: EVENTS_LOCATIONS_EXCLUDE_FAILURE,
        });
    }
};

export const addCourtExclusionList = (exclusionList) => async (dispatch, getState, { mainApi }) => {
    try {
        const { currentEvent } = getState().events;
        const event = currentEvent.data;

        dispatch({ type: EVENTS_LOCATIONS_EXCLUDE_REQUEST });

        await tmsEventsApi.addCourtToEventExclusions(mainApi, event.id, { courts: exclusionList });

        dispatch({ type: EVENTS_LOCATIONS_EXCLUDE_SUCCESS });
        dispatch(getEventLocations(event.id));
    } catch {
        dispatch({
            type: EVENTS_LOCATIONS_EXCLUDE_FAILURE,
        });
    }
};

export const getEventOfficials = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_OFFICIALS_FETCH_REQUEST });
        const res = await tmsEventsApi.getEventOfficials(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_OFFICIALS_FETCH_FAILURE });
        } else {
            dispatch({ type: EVENTS_OFFICIALS_FETCH_SUCCESS, data });
        }
    } catch {
        dispatch({
            type: EVENTS_OFFICIALS_FETCH_FAILURE,
        });
    }
};

export const saveEventOfficial = (eventId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_OFFICIALS_UPDATE_REQUEST });
        const res = await tmsEventsApi.saveEventOfficial(mainApi, eventId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_OFFICIALS_UPDATE_FAILURE });
            throw new Error('Error saving event official.');
        } else {
            dispatch({ type: EVENTS_OFFICIALS_UPDATE_SUCCESS, data });
            dispatch(getEventOfficials(eventId));
        }
    } catch {
        dispatch({
            type: EVENTS_OFFICIALS_UPDATE_FAILURE,
        });
        throw new Error('Error saving event official.');
    }
};

export const updateEventOfficial = (eventId, officialId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_OFFICIALS_UPDATE_REQUEST });
        const res = await tmsEventsApi.updateEventOfficial(mainApi, eventId, officialId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_OFFICIALS_UPDATE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error updating event official.',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: EVENTS_OFFICIALS_UPDATE_SUCCESS, data });
            dispatch(getEventOfficials(eventId));
        }
    } catch (error) {
        dispatch({
            type: EVENTS_OFFICIALS_UPDATE_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error updating event official.',
            error,
        }));
    }
};

export const inactivateEventOfficial = (eventId, officialId, payload) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_OFFICIALS_UPDATE_REQUEST });
        const res = await tmsEventsApi.inactivateEventOfficial(mainApi, eventId, officialId, payload);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_OFFICIALS_UPDATE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error removing event official.',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: EVENTS_OFFICIALS_UPDATE_SUCCESS, data });
            dispatch(getEventOfficials(eventId));
        }
    } catch (error) {
        dispatch({
            type: EVENTS_OFFICIALS_UPDATE_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error removing event official.',
            error,
        }));
    }
};

export const getMatchOfficials = (eventId, drawId, matchId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_GET_MATCH_OFFICIALS_REQUEST });
        const result = await tmsEventsApi.getMatchOfficials(mainApi, eventId, matchId);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_GET_MATCH_OFFICIALS_FAILURE });
        } else {
            dispatch({
                type: EVENTS_GET_MATCH_OFFICIALS_SUCCESS,
                payload: { drawId, matchId, data: data.officials },
            });
        }
    } catch {
        dispatch({ type: EVENTS_GET_MATCH_OFFICIALS_FAILURE });
    }
};

export const getDrawOfficials = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_GET_DRAW_OFFICIALS_REQUEST });
        const result = await tmsEventsApi.getDrawOfficials(mainApi, eventId, drawId);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_GET_DRAW_OFFICIALS_FAILURE });
        } else {
            dispatch({
                type: EVENTS_GET_DRAW_OFFICIALS_SUCCESS,
                payload: { drawId, eventId, data },
            });
        }
    } catch {
        dispatch({ type: EVENTS_GET_DRAW_OFFICIALS_FAILURE });
    }
};

export const addMatchOfficial = ({ drawId, matchId, payload }) => async (dispatch, getState, { mainApi }) => {
    const { events } = getState();
    const event = events.currentEvent.data;
    try {
        dispatch({ type: EVENTS_ADD_MATCH_OFFICIAL_REQUEST });
        const result = await tmsEventsApi.addMatchOfficial(mainApi, event.id, drawId, matchId, payload);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_ADD_MATCH_OFFICIAL_FAILURE });
            dispatch(showErrorPopup({
                message: 'Adding match official failed.',
                error: data.error,
            }));
        } else {
            dispatch(getMatchOfficials(event.id, drawId, matchId));
        }
    } catch {
        dispatch({ type: EVENTS_ADD_MATCH_OFFICIAL_FAILURE });
    }
};

export const deleteMatchOfficial = ({ drawId, matchId, officialId }) => async (dispatch, getState, { mainApi }) => {
    const { events } = getState();
    const event = events.currentEvent.data;
    try {
        dispatch({ type: EVENTS_DELETE_MATCH_OFFICIAL_REQUEST });
        const result = await tmsEventsApi.deleteMatchOfficial(mainApi, event.id, drawId, matchId, officialId);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_DELETE_MATCH_OFFICIAL_FAILURE });
            dispatch(showErrorPopup({
                message: 'Deleting match official failed.',
                error: data.error,
            }));
        } else {
            dispatch({ type: EVENTS_DELETE_MATCH_OFFICIAL_SUCCESS, payload: { matchId } });
        }
    } catch {
        dispatch({ type: EVENTS_DELETE_MATCH_OFFICIAL_FAILURE });
    }
};

export const getDivisionAcceptanceList = ({ eventId, divisionId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_ACCEPTANCE_FETCH_REQUEST, divisionId });
    try {
        const res = await tmsEventsApi.getDivisionAcceptanceList(mainApi, { eventId, divisionId });
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_ACCEPTANCE_FETCH_FAILURE, divisionId });
        } else if (data) {
            dispatch({ type: EVENTS_ACCEPTANCE_FETCH_SUCCESS, data, divisionId });
        } else {
            dispatch({ type: EVENTS_ACCEPTANCE_FETCH_FAILURE, divisionId });
        }
    } catch {
        dispatch({ type: EVENTS_ACCEPTANCE_FETCH_FAILURE, divisionId });
    }
};

export const fetchOrderOfPlay = (eventId) => async (dispatch, getState, { mainApi }) => {
    const res = await eventsApi.getOrderOfPlay(mainApi, eventId);
    dispatch({ type: EVENTS_ORDER_OF_PLAY_FETCH_SUCCESS, payload: res.data.matches });
};

export const getEventSafeSport = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_SAFESPORT_FETCH_REQUEST });

        const { auth } = getState();

        if (auth.user === null) {
            dispatch({
                type: EVENTS_SAFESPORT_FETCH_FAILURE,
            });
        } else {
            const res = await tmsEventsApi.getEventSafeSport(mainApi, eventId);
            const { data } = res;
            if (data.error) {
                console.log(data.error);
                dispatch({
                    type: EVENTS_SAFESPORT_FETCH_FAILURE,
                    res,
                });
            } else {
                dispatch({
                    type: EVENTS_SAFESPORT_FETCH_SUCCESS,
                    res,
                });
                return res.data;
            }
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: EVENTS_SAFESPORT_FETCH_FAILURE });
    }
};

export const getEventRegions = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: EVENTS_GET_EVENT_REGIONS_FETCH,
    });

    try {
        const response = await tmsEventsApi.getEventRegions(mainApi, eventId);
        if (response.status === 200) {
            dispatch({
                type: EVENTS_GET_EVENT_REGIONS_SUCCESS,
                payload: response.data,
            });
        } else {
            dispatch(showErrorPopup({
                error: 'Error fetching Event Regions',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching Event Regions',
            error,
        }));
    }
};

export const describeEventFollowUps = ({ data, hasUser, getAcceptanceLists }) => {
    const followUps = [];
    if (hasUser) {
        if (data?.scheduleType?.value === eventsConstants.ORDER_OF_PLAY) {
            followUps.push({ kind: 'orderOfPlay' });
        }
        if (data?.scheduleType?.value === eventsConstants.MATCH_SHEET) {
            followUps.push({ kind: 'matchSheet' });
        }
        if (data?.eventType?.id === EventTypes.TEAM_LEAGUE) {
            followUps.push({ kind: 'teamStandings' });
        }
        const isNationalPathway = data?.eventTours?.some(t => t.id === EventTours.NationalPathwayTourTagId);
        if (isNationalPathway) {
            followUps.push({ kind: 'regions' });
        }
    } else if (getAcceptanceLists && data?.eventDivisions?.length) {
        data.eventDivisions.forEach(div => followUps.push({ kind: 'divisionAcceptanceList', divisionId: div.id }));
    }
    return followUps;
};

export const buildFetchErrorData = (error) => {
    const data = error?.response ? error.response.data : null;
    const redirectUrl = data?.clubId ? `/clubs/${data.clubId}` : null;
    return {
        message: data,
        statusCode: error?.response?.status,
        redirectUrl,
    };
};

const EVENT_FOLLOW_UP_DISPATCH = {
    orderOfPlay: ({ eventId }) => fetchOrderOfPlay(eventId),
    matchSheet: ({ eventId }) => getMatchSheet(eventId),
    teamStandings: ({ eventId }) => getEventTeamStandings(eventId),
    regions: ({ eventId }) => getEventRegions(eventId),
    divisionAcceptanceList: ({ eventId, divisionId }) => getDivisionAcceptanceList({ eventId, divisionId }),
};

const loadUserScopedEventData = (eventId, optimized) => (dispatch) => {
    dispatch(getEventLocations(eventId));
    dispatch(getEventOfficials(eventId));
    if (optimized) {
        dispatch(getEventDraws(eventId));
    } else {
        defaultInitDrawsTabState();
    }
};

export const getEvent = (eventId, forEdit, adminSplash, showSplash = true, optimized = true, getAcceptanceLists = false) => async (dispatch, getState, { mainApi }) => {
    const { user } = getState().auth;
    dispatch({ type: EVENTS_FETCH_REQUEST });
    if (showSplash) {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait while we\'re loading your event',
        });
    }
    const hideSplashIfShown = () => {
        if (showSplash) {
            dispatch({ type: 'SPLASH_HIDE' });
        }
    };

    try {
        const res = await tmsEventsApi.get(mainApi, eventId, forEdit, optimized);
        if (res.data.error) {
            dispatch({ type: EVENTS_FETCH_FAILURE, res });
            hideSplashIfShown();
            return undefined;
        }

        describeEventFollowUps({ data: res.data, hasUser: Boolean(user), getAcceptanceLists })
            .forEach(f => dispatch(EVENT_FOLLOW_UP_DISPATCH[f.kind]({ ...f, eventId })));

        hideSplashIfShown();

        if (forEdit) {
            return res.data;
        }

        dispatch({ type: EVENTS_FETCH_SUCCESS, res });
        if (user) {
            dispatch(loadUserScopedEventData(eventId, optimized));
        }
        if (adminSplash) {
            dispatch(showAdminSplash(adminSplash));
        }
        dispatch(getEventSafeSport(eventId));
        return res.data;
    } catch (error) {
        if (forEdit) {
            return { error: true, redirectUrl: buildFetchErrorData(error).redirectUrl };
        }
        console.log('getEvent error');
        dispatch({ type: EVENTS_FETCH_FAILURE, data: buildFetchErrorData(error) });
        hideSplashIfShown();
        return undefined;
    }
};

export const getDrawsViewEvent = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_DRAWS_VIEW_FETCH_REQUEST });
    try {
        const res = await tmsEventsApi.getDrawsView(mainApi, eventId);
        if (res.data?.error) {
            dispatch({ type: EVENTS_DRAWS_VIEW_FETCH_FAILURE, res });
            return undefined;
        }
        dispatch({ type: EVENTS_DRAWS_VIEW_FETCH_SUCCESS, res });
        return res.data;
    } catch (error) {
        dispatch({ type: EVENTS_DRAWS_VIEW_FETCH_FAILURE, res: { data: buildFetchErrorData(error) } });
        return undefined;
    }
};

export const getR2Event = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getR2(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            console.log(data.error);
        } else {
            return res.data;
        }
    } catch (error) {
        console.log(error);
    }
};

export const importR2Event = (eventId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.importR2(mainApi, eventId, values);
        const { data } = res;
        if (data.error) {
            console.log(data.error);
        } else {
            return res.data;
        }
    } catch (error) {
        console.log(error);
    }
};

export const initDraws = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_DRAWS_INIT_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Creating Draws',
        description: 'Creating your tournament draws',
    });
    try {
        const res = await tmsEventsApi.initDraws(mainApi, eventId);
        if (res.data.error) {
            dispatch({
                type: EVENTS_DRAWS_INIT_FAILURE,
                res,
            });
            dispatch(showErrorPopup({
                message: 'Error initializing draws',
                error: res.data.error,
            }));
            dispatch({
                type: 'SPLASH_HIDE',
            });
        } else {
            dispatch({
                type: EVENTS_DRAWS_INIT_SUCCESS,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: EVENTS_DRAWS_INIT_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error initializing draws',
            error,
        }));
    }
};

export const deleteDraw = (eventId, drawId, isCollege = false) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: `Deleting ${isCollege ? 'Lineup' : 'Draw'}`,
        description: `Please wait while we're deleting the ${isCollege ? 'lineup' : 'draw'}`,
    });

    try {
        dispatch({ type: EVENTS_DRAWS_DELETE_REQUEST });
        const res = await tmsEventsApi.deleteDraw(mainApi, eventId, drawId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_DRAWS_DELETE_FAILURE });
        } else {
            dispatch({ type: EVENTS_DRAWS_DELETE_SUCCESS, drawId });
        }
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch({
            type: EVENTS_DRAWS_DELETE_FAILURE,
        });
    }
};

export const resetEvent = () => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_RESET_REQUEST });
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    try {
        await tmsEventsApi.resetEvent(mainApi, event.id);
        dispatch({ type: EVENTS_RESET_SUCCESS });
        // reload event
        dispatch(getEvent(event.id, false, 'Your event has been reset!', false));
    } catch (error) {
        dispatch({ type: EVENTS_RESET_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error resetting event',
            error,
        }));
    }
};

export const sendEventInviteToMembers = () => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    try {
        await clubsApi.sendEventInviteToMembers(mainApi, event.id, event.club.id);
        dispatch(showAdminSplash('Invite Email Sent!'));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error Sending Invite.',
            error,
        }));
    }
};

export const autofillDraw = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    const { events } = getState();
    const event = events.currentEvent.data;
    dispatch({ type: EVENTS_DRAWS_AUTOFILL_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Adding Players',
        description: 'Auto-filling your draw',
    });
    try {
        const res = await tmsEventsApi.autofillDraw(mainApi, eventId, drawId, event);
        if (res.data.error) {
            dispatch({
                type: EVENTS_DRAWS_AUTOFILL_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error auto-populating draw',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: EVENTS_DRAWS_AUTOFILL_SUCCESS,
                res,
            });
            if (event.scheduleType.value === 'orderofplay') {
                dispatch(fetchOrderOfPlay(event.id));
            }
            dispatch({
                type: 'SPLASH_HIDE',
            });
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: EVENTS_DRAWS_AUTOFILL_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error auto-populating draw',
            error: getApiErrorMessage(error),
        }));
    }
};

export const autofillDrawRound = (eventId, drawId, roundId, selected, selectedTeams) => async (dispatch, getState, { mainApi }) => {
    const { events } = getState();
    const event = events.currentEvent.data;
    dispatch({ type: EVENTS_DRAWS_AUTOFILL_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Adding Players',
        description: 'Auto-filling your draw round',
    });
    try {
        const res = await tmsEventsApi.autofillDrawRound(mainApi, eventId, drawId, roundId, selected, selectedTeams, event);
        if (res.data.error) {
            dispatch({
                type: EVENTS_DRAWS_AUTOFILL_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error auto-populating draw round',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: EVENTS_DRAWS_AUTOFILL_SUCCESS,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: EVENTS_DRAWS_AUTOFILL_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error auto-populating draw round',
            error,
        }));
    }
};

export const publishDraws = () => async (dispatch, getState, { mainApi }) => {
    const { events } = getState();
    const event = events.currentEvent.data;
    dispatch({ type: EVENTS_DRAWS_PUBLISH_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Publishing',
        description: 'Publishing your draws',
    });
    try {
        const res = await tmsEventsApi.publishDraws(mainApi, event.id, event);
        if (res.data.error) {
            dispatch({
                type: EVENTS_DRAWS_PUBLISH_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error publishing draws',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: EVENTS_DRAWS_PUBLISH_SUCCESS,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: EVENTS_DRAWS_PUBLISH_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error publishing draws',
            error,
        }));
    }
};

export const saveEventDraws = (eventUpdate) => async (dispatch, getState, { mainApi }) => {
    const { events } = getState();
    let event = events.currentEvent.data;
    const { draws, registeredPlayers, teams } = eventUpdate || {};

    if (eventUpdate) {
        event = {
            ...event,
            ...(draws ? { draws } : {}),
            ...(registeredPlayers ? { registeredPlayers } : {}),
            ...(teams ? { teams } : {}),
        };
    }

    dispatch({ type: EVENTS_DRAWS_SAVE_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_SAVING',
        title: 'Saving',
        description: 'Updating your draws',
    });
    try {
        const res = await tmsEventsApi.saveDraws(mainApi, event);
        if (res.data.error) {
            dispatch({
                type: EVENTS_DRAWS_SAVE_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error saving draws',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: EVENTS_DRAWS_SAVE_SUCCESS,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: EVENTS_DRAWS_SAVE_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error saving draws',
            error,
        }));
        throw error;
    }
};

export const postEventScore = (values, indexes, eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_POST_SCORE_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_SAVING',
        title: 'Saving Scores',
        description: 'Saving match scores',
    });
    try {
        const res = await postScore(mainApi, values);
        if (res.data.error) {
            dispatch({
                type: EVENTS_POST_SCORE_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error saving scores',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: EVENTS_POST_SCORE_SUCCESS,
                result: res.data.result,
                indexes,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(getEvent(eventId));
        }
    } catch (error) {
        dispatch({
            type: EVENTS_POST_SCORE_FAILURE,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        if (error?.response?.data?.DisplayMessage) {
            if (error.response.data.MessageStatusCode === 80203) {
                dispatch(showErrorPopup({
                    message: error.response.data.DisplayMessage,
                    error,
                }));
            }
        } else {
            dispatch(showErrorPopup({
                message: 'Error saving scores',
                error,
            }));
        }
    }
};

export const addPlayerByOrganizer = (eventId, data) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.registerPlayerByOrganizer(mainApi, eventId, data);
        return res.data;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error registering player.',
            error: err,
        }));
        return false;
    }
};

export const sendInvitationToGroup = (eventId, clubId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_SEND_INVITATION_TO_GROUP });
    try {
        const res = await tmsEventsApi.sendInvitationToGroup(mainApi, eventId, clubId);
        if (res.data.error) {
            dispatch({ type: EVENTS_SEND_INVITATION_TO_GROUP_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error Sending Invitation',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: EVENTS_SEND_INVITATION_TO_GROUP_SUCCESS });
            dispatch({ type: NOTIFICATIONS_SHOW_SUCCESS_TOAST, message: 'Invitation Sent' });
        }
    } catch (error) {
        dispatch({ type: EVENTS_SEND_INVITATION_TO_GROUP_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error Sending Invitation',
            error,
        }));
    }
};

export const sendMessageToPlayers = (message, eventId, drawId, sendCopyToOrganizer = false) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_SEND_MESSAGE_TO_PLAYERS });
    try {
        const res = await sendMessage(mainApi, message, eventId, drawId, sendCopyToOrganizer);
        if (res.data.error) {
            dispatch({ type: EVENTS_SEND_MESSAGE_TO_PLAYERS_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error Sending Message',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: EVENTS_SEND_MESSAGE_TO_PLAYERS_SUCCESS });
            dispatch({ type: NOTIFICATIONS_SHOW_SUCCESS_TOAST, message: 'Message Sent' });
        }
    } catch (error) {
        dispatch({ type: EVENTS_SEND_MESSAGE_TO_PLAYERS_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error Sending Message',
            error: error.response.data,
        }));
    }
};

export const clearScoreResult = (match, indexes) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_CLEAR_SCORE_REQUEST });
    try {
        const res = await clearScore(mainApi, match);
        if (res.data.error) {
            dispatch({
                type: EVENTS_CLEAR_SCORE_FAILURE,
                res,
            });
            dispatch(showErrorPopup({
                message: 'Error clearing score',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: EVENTS_CLEAR_SCORE_SUCCESS,
                result: null,
                indexes,
            });
        }
    } catch (error) {
        dispatch({
            type: EVENTS_CLEAR_SCORE_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error clearing scores',
            error,
        }));
    }
};

export const cropEventBanner = (eventId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'EVENTS:CROP_BANNER_PHOTO',
        });
        const res = await submitEventBannerCrop(mainApi, eventId, values);
        dispatch({
            type: EVENTS_CROP_BANNER_PHOTO_SUCCESS,
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image data.',
            error: err,
        }));
        throw err;
    }
};

export const removeBannerPhoto = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'EVENTS:REMOVE_BANNER_PHOTO',
        });
        const res = await removeEventBannerPhoto(mainApi, eventId);
        dispatch({
            type: EVENTS_REMOVE_BANNER_PHOTO_SUCCESS,
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error removing event banner.',
            error: err,
        }));
        throw err;
    }
};

export const clearJustPublishedFlag = () => async (dispatch) => {
    dispatch({ type: EVENTS_CLEAR_JUST_PUBLISHED_FLAG });
};

export const getEventMetaData = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.eventMeta(mainApi, eventId);
        if (res.data.error) {
            console.log('ERROR GETTING EVENT META DATA', res.data.error);
        } else {
            dispatch({
                type: EVENTS_META_FETCH_SUCCESS,
                data: res.data,
            });
        }
    } catch (error) {
        console.log('ERROR GETTING EVENT META DATA 2', error);
    }
};

export const getDualMatchEvent = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: 'DUALMATCH:FETCH_PROFILE' });
        const res = await eventsApi.getDualMatchProfile(mainApi, eventId);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error loading dual match.',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: 'DUALMATCH:FETCH_PROFILE_SUCCESS',
                data: res.data,
            });
        }
    } catch (error) {
        dispatch({ type: 'DUALMATCH:FETCH_PROFILE_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error loading dual match.',
            error: error.response.statusText,
        }));
    }
};

// this was changed to new tms events route but is only used by old dual match profile page.
// above function is what the function used to be.
// export const getDualMatchEvent = (eventId) => async (dispatch, getState, { mainApi }) => {
//     try {
//         console.log("FETCHING DUAL MATCH", eventId, !!eventId)
//         if (parseInt(eventId)) {
//             const res = await tmsEventsApi.get(mainApi, eventId)
//             if (res.data.error) {
//                 console.log("ERROR GETTING DUAL MATCH", res.data.error)
//             } else {
//                 dispatch({
//                     type: 'DUALMATCH:FETCH_PROFILE_SUCCESS',
//                     res
//                 });
//             }
//         } else {
//             //use mock event for testing
//             dispatch({
//                 type: 'DUALMATCH:FETCH_PROFILE_SUCCESS',
//                 res: { data: mockDualMatch }
//             });
//         }
//     } catch (error) {
//         console.log("ERROR GETTING DUAL MATCH 2", error)
//     }
// };

export const updateEventTeamScores = (eventId, scoreObj) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await eventsApi.updateEventTeamScores(mainApi, eventId, scoreObj);
        dispatch({
            type: EVENTS_UPDATE_TEAM_SCORES_SUCCESS,
            data: scoreObj,
        });
        console.log('updateEventTeamScores success', res);
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error updating event team scores.',
            error: err,
        }));
        throw err;
    }
};

export const updateMatchPositions = (eventId, drawId, matchId, position, data) => async (dispatch, getState, { mainApi }) => {
    console.log('updateMatchPositions', eventId, drawId, matchId, position, data);
    try {
        // update view model
        dispatch({ type: EVENTS_UPDATE_MATCH_POSITION_REQUEST, drawId, matchId, position, data });
        // post to api
        let positionObj = {
            positions: {
                [position === 'position1' ? 1 : 2]: !data.players ? null : data,
            },
        };

        // for doubles match clear functionality FLX-304
        if (data.players && data?.players?.length > 1 && (!data?.players[0] || !data?.players[1])) {
            positionObj = {
                positions: {
                    [position === 'position1' ? 1 : 2]: null,
                },
            };
        }
        const res = await eventsApi.updateMatchPositions(mainApi, matchId, positionObj);
        dispatch({ type: EVENTS_UPDATE_MATCH_POSITION_SUCCESS, drawId, matchId });
        console.log('updateMatchPositions success', res);
    } catch (err) {
        // reload event to restore view model on error
        dispatch(getEvent(eventId));
        dispatch(showErrorPopup({
            message: 'Error updating match positions.',
            error: err,
        }));
        throw err;
    }
};

export const addMatchToRound = (drawId, roundId, data) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await eventsApi.addMatchToRound(mainApi, roundId, data || {});
        dispatch({ type: EVENTS_ADD_MATCH_TO_ROUND, drawId, roundId, matchIds: res.data.data.matchIds });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error adding new match.',
            error: err,
        }));
        throw err;
    }
};

export const deleteMatch = (drawId, matchId) => async (dispatch, getState, { mainApi }) => {
    try {
        await eventsApi.deleteMatch(mainApi, matchId);
        dispatch({ type: EVENTS_DELETE_MATCH, drawId, matchId });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error deleting match.',
            error: err,
        }));
        throw err;
    }
};

export const publishEvent = () => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Publishing',
        description: 'Please wait while we\'re publishing your event',
    });
    try {
        // eslint-disable-next-line no-undef
        await tmsEventsApi.publishEvent(mainApi, event.id);
        dispatch({ type: EVENTS_PUBLISH_SUCCESS, eventId: event.id });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showAdminSplash('Event has been published.'));
        if (isTeamTennisClub(event.club.tierType)) {
            dispatch(getAdultTeamTennisEvents({ clubId: event.club.id }));
        }
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error publishing event.',
            error: err,
        }));
        throw err;
    }
};

export const unPublishEvent = () => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Unpublishing',
        description: 'Please wait while we\'re unpublishing your event',
    });
    try {
        const res = await tmsEventsApi.unPublishEvent(mainApi, event.id);
        console.log('unpublishEvent success', res);
        dispatch({ type: EVENTS_UNPUBLISH_SUCCESS, eventId: event.id });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showAdminSplash('Your event has been unpublished!'));
        if (isTeamTennisClub(event.club.tierType)) {
            dispatch(getAdultTeamTennisEvents({ clubId: event.club.id }));
        }
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error unpublishing event.',
            error: err,
        }));
        throw err;
    }
};

export const addDraw = (eventId, data) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await eventsApi.addDraw(mainApi, eventId, data);
        console.log('addDraw success', res);
        dispatch({ type: EVENTS_ADD_DRAW, eventId, draw: res.data });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error adding new draw.',
            error: err,
        }));
        throw err;
    }
};

export const updateDraw = (eventId, drawId, data) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await eventsApi.updateDraw(mainApi, eventId, drawId, data);
        console.log('updateDraw success', res);
        dispatch({ type: EVENTS_UPDATE_DRAW, eventId, drawId, drawName: data.name });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error updating draw.',
            error: err,
        }));
        throw err;
    }
};

// obselete
export const createAutomatedDraw = (payload) => async (dispatch, getState, { mainApi }) => {
    const { events } = getState();
    const event = events.currentEvent.data;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Creating Draw',
        description: 'Please wait while we\'re creating your automated draw',
    });
    try {
        const res = await tmsEventsApi.createAutomatedDraw(mainApi, event.id, payload);
        dispatch({
            type: 'SPLASH_HIDE',
        });
        return res.data;
    } catch (error) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error creating draw',
            error,
        }));
        throw error;
    }
};

export const saveOrderOfPlay = (eventId, matchId, orderOfPlay) => async (dispatch, getState, { mainApi }) => {
    try {
        const orderOfPlayPayload = {
            ...orderOfPlay,
        };

        const res = await eventsApi.saveOrderOfPlay(mainApi, eventId, orderOfPlayPayload);

        if (res.status === 200) {
            dispatch({
                type: EVENTS_ORDER_OF_PLAY_SAVE_SUCCESS,
                payload: {
                    matchId,
                    ...orderOfPlay,
                },
            });
            dispatch(fetchOrderOfPlay(eventId));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error saving order of play.',
            error,
        }));
        throw error;
    }
};

export const deleteOrderOfPlay = (eventId, matchId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await eventsApi.deleteOrderOfPlay(mainApi, eventId, matchId);
        if (res.status === 200) {
            dispatch({
                type: EVENTS_ORDER_OF_PLAY_DELETE_SUCCESS,
                payload: {
                    matchId,
                },
            });
            dispatch(fetchOrderOfPlay(eventId));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting order of play.',
            error,
        }));
        throw error;
    }
};

export const invitePlayersToEvent = (playersList) => async (dispatch, getState, { mainApi }) => {
    try {
        const { currentEvent } = getState().events;
        const { id, creatingMemberId } = currentEvent.data;
        dispatch({ type: EVENTS_INVITE_PLAYERS_REQUEST });
        const result = await eventsApi.invitePlayersToEvent(mainApi, id, {
            eventInvites: filterMembers(playersList, creatingMemberId),
        });
        const { data } = result;
        if (data.error) {
            console.log('error', data.error);
            dispatch({ type: EVENTS_INVITE_PLAYERS_FAILURE, data: { playersInvited: false } });
        } else {
            console.log('error', data);
            dispatch({ type: EVENTS_INVITE_PLAYERS_SUCCESS, data: { data: data.data, playersInvited: true } });
        }
    } catch (err) {
        console.log('error', err);
        dispatch({ type: EVENTS_INVITE_PLAYERS_FAILURE, data: { playersInvited: false } });
    }
};

export const getRegPayments = ({ eventId, memberId }) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_REGPAYMENTS_FETCH_REQUEST });
        const res = await tmsEventsApi.getRegPayments(mainApi, { eventId, memberId });
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_REGPAYMENTS_FETCH_FAILURE });
        } else {
            dispatch({ type: EVENTS_REGPAYMENTS_FETCH_SUCCESS, data });
        }
    } catch {
        dispatch({
            type: EVENTS_REGPAYMENTS_FETCH_FAILURE,
        });
    }
};
export const fetchEventAttachments = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_FETCH_ATTACHMENT_REQUEST });
        const result = await eventsApi.getEventAttachments(mainApi, eventId);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_FETCH_ATTACHMENT_FAILURE });
        } else {
            dispatch({ type: EVENTS_FETCH_ATTACHMENT_SUCCESS, data });
        }
    } catch {
        dispatch({ type: EVENTS_FETCH_ATTACHMENT_FAILURE });
    }
};

export const uploadEventAttachment = ({ eventId, formData }) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENTS_UPLOAD_ATTACHMENT_REQUEST });
        const result = await eventsApi.uploadEventAttachment(mainApi, eventId, formData);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_UPLOAD_ATTACHMENT_FAILURE });
        } else {
            dispatch({ type: NOTIFICATIONS_SHOW_SUCCESS_TOAST, message: 'Attachment uploaded' });
            dispatch({ type: EVENTS_UPLOAD_ATTACHMENT_SUCCESS });
            dispatch(fetchEventAttachments(eventId));
        }
    } catch {
        dispatch({ type: EVENTS_UPLOAD_ATTACHMENT_FAILURE });
    }
};

export const contactSelectedMembers = (eventId, formData) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await eventsApi.contactSelectedMembers(mainApi, eventId, formData);
        if (res.data?.error) {
            dispatch(showErrorPopup({
                message: 'Error sending message',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: NOTIFICATIONS_SHOW_SUCCESS_TOAST, message: 'Message Sent' });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error sending message',
            error: error?.response?.statusText,
        }));
    }
};

export const deleteEventAttachment = (eventId, fileId) => async (dispatch, getState, { mainApi }) => {
    try {
        await eventsApi.deleteEventAttachment(mainApi, eventId, fileId);
        dispatch(fetchEventAttachments(eventId));
        dispatch({ type: NOTIFICATIONS_SHOW_SUCCESS_TOAST, message: 'Attachment deleted' });
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting attachment',
            error,
        }));
    }
};

export const updateEventInStore = (res) => (dispatch) => {
    dispatch({ type: EVENTS_REG_SUCCESS, res });
};

export const addTeammateToDivison = ({ divisionIndex, player2 }) => (dispatch) => {
    dispatch({ type: EVENTS_REG_ADD_TEAMMATE, payload: { divisionIndex, player2 } });
};

export const selfWithdrawFromEvent = (withdrawPayload) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.selfWithdraw(mainApi, withdrawPayload);

        if (response.status === 200) {
            await dispatch(getEvent(withdrawPayload.eventId));
            // selfWithdrawAllowed comes from the registrations API, not getEvent, so refresh it to avoid a stale re-submit.
            dispatch(getRegistrations(withdrawPayload.eventId)).catch(() => {});
            dispatch(getCurrentMemberRegistration(withdrawPayload.eventId)).catch(() => {});
        } else {
            dispatch(showErrorPopup({
                message: 'Error withdrawing registration',
                error: response.data,
            }));
        }
    } catch (e) {
        dispatch(showErrorPopup({
            message: 'Error withdrawing registration',
            error: e,
        }));
    }
};

export const getEventTemplate = (templateId, redirectUrl, clubId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_FETCH_REQUEST });
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Loading',
        description: 'Please wait while we\'re preparing your template preview',
    });
    try {
        const res = await tmsEventsApi.getEventTemplate(mainApi, templateId, clubId);
        if (res.data.error) {
            dispatch({
                type: EVENTS_FETCH_FAILURE,
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
        } else {
            dispatch({
                type: 'SPLASH_HIDE',
            });
            console.log('getEvent success');
            dispatch({
                type: EVENTS_FETCH_SUCCESS,
                res,
            });
            console.log('after getEvent success');
        }
    } catch {
        console.log('getEvent error');
        dispatch({
            type: EVENTS_FETCH_FAILURE,
            data: { redirectUrl },
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    }
};

export const updateEventDraws = (payload) => (dispatch) => {
    dispatch({
        type: EVENTS_UPDATE_DRAWS,
        payload,
    });
};

export const updateEventSchedule = (scheduleType) => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const event = currentEvent.data;
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait while we\'re loading your event',
        });

        dispatch({ type: EVENTS_UPDATE_SCHEDULE_TYPE_REQUEST });
        const result = await tmsEventsApi.updateScheduleType(mainApi, event.id, {
            drawSchedule: scheduleType.value,
        });
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENTS_UPDATE_SCHEDULE_TYPE_FAILURE });
        } else {
            dispatch({ type: EVENTS_UPDATE_SCHEDULE_TYPE_SUCCESS });
            dispatch({
                type: EVENTS_UPDATE_SCHEDULE_TYPE,
                payload: scheduleType,
            });
            if (scheduleType.value === 'orderofplay') {
                dispatch(fetchOrderOfPlay(event.id));
            } else {
                dispatch(getMatchSheet(event.id));
            }
            dispatch(getEventDraws(event.id, true));
            dispatch({
                type: 'SPLASH_HIDE',
            });
        }
    } catch {
        dispatch({ type: EVENTS_UPDATE_SCHEDULE_TYPE_FAILURE });
    }
};

export const addTeamStanding = (eventId, teamStanding) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.addTeamStanding(mainApi, eventId, teamStanding);

    if (response.status === 200) {
        dispatch(getEventTeamStandings(eventId));
    }
};

export const editTeamStanding = (eventId, teamStanding) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.editTeamStanding(mainApi, eventId, teamStanding);

    if (response.status === 200) {
        dispatch({
            type: EVENTS_EDIT_TEAM_STANDING_SUCCESS,
            payload: teamStanding,
        });
    }
};

export const deleteTeamStanding = (eventId, standingId) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.deleteTeamStanding(mainApi, eventId, standingId);

    if (response.status === 200) {
        dispatch({
            type: EVENTS_DELETE_TEAM_STANDING_SUCCESS,
            payload: standingId,
        });
    }
};

export const includeInHighSchoolStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_INCLUDE_IN_CONFERENCE_REQUEST });
    try {
        const res = await tmsEventsApi.includeInHighSchoolStandings(mainApi, eventId);
        if (res.data.error) {
            dispatch({ type: EVENTS_INCLUDE_IN_CONFERENCE_FAILURE, res });
        } else {
            dispatch({ type: EVENTS_INCLUDE_IN_CONFERENCE_SUCCESS, eventId });
            return res.data;
        }
    } catch (error) {
        dispatch({ type: EVENTS_INCLUDE_IN_CONFERENCE_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error including event in conference',
            error,
        }));
    }
};

export const omitFromHighSchoolStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_OMIT_FROM_CONFERENCE_REQUEST });
    try {
        const res = await tmsEventsApi.omitFromHighSchoolStandings(mainApi, eventId);
        if (res.data.error) {
            dispatch({ type: EVENTS_OMIT_FROM_CONFERENCE_FAILURE, res });
        } else {
            dispatch({ type: EVENTS_OMIT_FROM_CONFERENCE_SUCCESS, eventId });
            return res.data;
        }
    } catch (error) {
        dispatch({ type: EVENTS_OMIT_FROM_CONFERENCE_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error omitting event from conference',
            error,
        }));
    }
};

export const includeInAttStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'EVENTS_INCLUDE_IN_ATT_STANDINGS_REQUEST' });
    try {
        const res = await tmsEventsApi.includeInAttStandings(mainApi, eventId);
        if (res.data.error) {
            dispatch({ type: 'EVENTS_INCLUDE_IN_ATT_STANDINGS_FAILURE', res });
        } else {
            dispatch({ type: EVENTS_INCLUDE_IN_ATT_STANDINGS_SUCCESS, eventId });
            return res.data;
        }
    } catch (error) {
        dispatch({ type: 'EVENTS_INCLUDE_IN_ATT_STANDINGS_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error including event in standings',
            error,
        }));
    }
};

export const omitFromAttStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'EVENTS_OMIT_FROM_ATT_STANDINGS_REQUEST' });
    try {
        const res = await tmsEventsApi.omitFromAttStandings(mainApi, eventId);
        if (res.data.error) {
            dispatch({ type: 'EVENTS_OMIT_FROM_ATT_STANDINGS_FAILURE', res });
        } else {
            await dispatch({ type: EVENTS_OMIT_FROM_ATT_STANDINGS_SUCCESS, eventId });
            return res.data;
        }
    } catch (error) {
        dispatch({ type: 'EVENTS_OMIT_FROM_ATT_STANDINGS_REQUEST_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error omitting event from standings',
            error,
        }));
    }
};

export const getDrawPlayerContactInfo = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.fetchDrawPlayersContactInfo(mainApi, eventId, drawId);
        if (res.status === 200) {
            dispatch({
                type: EVENTS_DRAW_CONTACTS_SUCCESS,
                payload: res.data,
            });
        }
    } catch (error) {
        console.log('error get draw player contact info', error);
    }
};

export const getInvitations = () => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getInvitations(mainApi);
        if (res.status === 200) {
            dispatch({
                type: 'HOMEPAGE_CONTENT:GET_INVITATIONS_SUCCESS',
                payload: res.data,
            });
        }
    } catch (error) {
        console.log('error getting invitations', error);
    }
};

export const acceptInvite = (eventId, divisionId, calledFromInvitations) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.acceptInvite(mainApi, eventId, divisionId);
        if (res.status === 200) {
            dispatch({ type: EVENTS_ACCEPT_INVITE_SUCCESS });
            if (calledFromInvitations) {
                dispatch(getInvitations());
            } else {
                dispatch(getEvent(eventId));
            }
        }
    } catch (error) {
        console.log('error accepting invite', error);
    }
};

export const declineInvite = (eventId, divisionId, calledFromInvitations) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.declineInvite(mainApi, eventId, divisionId);
        if (res.status === 200) {
            dispatch({ type: EVENTS_DECLINE_INVITE_SUCCESS });
            if (calledFromInvitations) {
                dispatch(getInvitations());
            } else {
                dispatch(getEvent(eventId));
            }
        }
    } catch (error) {
        console.log('error declining invite', error);
    }
};

export const getRestrictedDivisions = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getRestrictedDivisions(mainApi, eventId);
        if (res.status === 200) {
            return res.data;
        }
        return {};
    } catch (error) {
        console.log('error fetch restricted divisions', error);
    }
};

export const setPlayerWildcard = ({ eventId, divisionId, memberId, wildcardStateId }) => async (dispatch, getState, { mainApi }) => {
    const { currentEvent } = getState().events;
    const { acceptance } = currentEvent;
    dispatch({
        type: EVENTS_SET_PLAYER_WILDCARD,
    });

    try {
        const response = await tmsEventsApi.setPlayerWildcard(mainApi, { eventId, divisionId, memberId, wildcardStateId });
        if (response.status === 204) {
            dispatch({
                type: EVENTS_SET_PLAYER_WILDCARD_SUCCESS,
                payload: { divisionId, memberId, wildcardStateId },
            });
            if (acceptance && acceptance[divisionId]?.rankingType === acceptanceRankingValues.WTA) {
                dispatch(getDivisionAcceptanceList({ eventId, divisionId }));
            }
        } else {
            dispatch(showErrorPopup({
                message: 'Error setting player wildcard',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting player wildcard',
            error,
        }));
    }
};

export const getOrganizerRatings = ({ eventId }) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.getOrganizerRatings(mainApi, { eventId });
        if (response.status === 200) {
            dispatch({
                type: EVENTS_GET_ORGANIZER_RATINGS_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log('error fetch restricted divisions', error);
    }
};

export const setOrganizerRating = ({ eventId, divisionId, memberId, singlesRating, doublesRating }) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.setOrganizerRating(mainApi, { eventId, divisionId, memberId, singlesRating, doublesRating });
        if (response.status === 200) {
            dispatch({
                type: EVENTS_SET_ORGANIZER_RATINGS_SUCCESS,
                payload: { divisionId, memberId, singlesRating },
            });
        } else {
            dispatch(showErrorPopup({
                error: 'Error setting organizer rating',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting organizer rating',
            error,
        }));
    }
};

export const movePlayersToRound = (eventId, divisionId, { memberId, roundType, acceptanceType = null, isSpecialExempt = false }) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: EVENTS_MOVE_PLAYER_TO_ROUND,
    });

    try {
        const response = await tmsEventsApi.movePlayersToRound(mainApi, eventId, divisionId, { memberId, roundType, acceptanceType, isSpecialExempt });
        if (response.status === 204) {
            dispatch({
                type: EVENTS_MOVE_PLAYER_TO_ROUND_SUCCESS,
                payload: { divisionId, memberId, roundType, isSpecialExempt },
            });
            if (acceptanceType || isSpecialExempt) {
                dispatch(getDivisionAcceptanceList({ eventId, divisionId }));
            }
        } else {
            dispatch(showErrorPopup({
                error: 'Error moving player',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error moving player',
            error: getApiErrorMessage(error),
        }));
    }
};

export const setDrawTag = ({ eventId, drawId, memberId, teamId, tagId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: EVENTS_SET_DRAW_TAG,
    });

    try {
        const response = await tmsEventsApi.setDrawTag(mainApi, { eventId, drawId, memberId, teamId, tagId });
        if (response.status === 204) {
            dispatch({
                type: EVENTS_SET_DRAW_TAG_SUCCESS,
                payload: { drawId, memberId, teamId, tagId },
            });
        } else {
            dispatch(showErrorPopup({
                error: 'Error setting draw tag',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting draw tag',
            error,
        }));
    }
};

export const sendSchedulingMessage = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Sending Message',
            description: 'Please wait while we\'re sending message',
        });
        await tmsEventsApi.sendSchedulingMessage(mainApi, eventId);
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showAdminSplash('Message has been sent!'));
    } catch (error) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error sending message',
            error,
        }));
    }
};

export const sendGroupSMS = (eventId, payload, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        await tmsEventsApi.sendGroupSMS(mainApi, eventId, payload);
        dispatch(showSuccessToast({ title: 'Group SMS has been sent!' }));
        if (payload?.matchIds?.length) {
            dispatch(drawEditActions.getDraw({ eventId, drawId, setAsCurrentDraw: true }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error sending Group SMS',
            error,
        }));
    }
};

export const postNcsaReg = (payload) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_POST_NCSA_REG });
    const { auth } = getState();
    try {
        const res = await eventsApi.postNcsaReg(mainApi, payload);
        if (res.status === 200) {
            dispatch({ type: EVENTS_POST_NCSA_REG_SUCCESS });
            gtag('event', {
                category: 'NCSA',
                context: 'NCSA Registration Successful',
            });
            // segment track call - mapped to GA4
            if (window?.analytics) {
                window.analytics.track('NCSA Registration Successful', {
                    userId: auth?.user.id,
                });
            }
        } else {
            dispatch({ type: EVENTS_POST_NCSA_REG_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error submitting NCSA application',
                error: res.DisplayMessage,
            }));
            gtag('event', {
                category: 'NCSA',
                context: 'NCSA Registration Unsuccessful',
            });
            // segment track call - mapped to GA4
            if (window?.analytics) {
                window.analytics.track(`NCSA Registration Unsuccessful - ${res.status}`, {
                    userId: auth?.user.id,
                });
            }
        }
    } catch (error) {
        // segment track call - mapped to GA4
        if (window?.analytics) {
            switch (error.response.status) {
                case 409:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Duplicate Registration',
                    });
                    window.analytics.track('NCSA Duplicate Registration', {
                        userId: auth?.user.id,
                    });
                    break;
                case 422:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful - API Validation Error',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful - API Validation Error', {
                        userId: auth?.user.id,
                    });
                    break;
                case 500:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful - Internal Server Error',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful - Internal Server Error', {
                        userId: auth?.user.id,
                    });
                    break;
                case 400:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful - Bad Request',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful - Bad Request', {
                        userId: auth?.user.id,
                    });
                    break;
                case 405:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful - Method Not Allowed',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful - Method Not Allowed', {
                        userId: auth?.user.id,
                    });
                    break;
                default:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful', {
                        userId: auth?.user.id,
                    });
                    break;
            }
        }
        dispatch({ type: EVENTS_POST_NCSA_REG_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error submitting NCSA application',
            error: getApiErrorMessage(error),
        }));
    }
};
